import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import {
  getDivisionDoc,
  getLifterAwardsWeightClassDoc
} from 'util/lifterHelper';
import {
  getCurrentMeet,
  getCurrentPlatform,
  getCurrentAttempt,
  getCurrentLifter
} from 'selectors';

const AttemptCell = ({currentLifter, liftName, attemptNumber, currentAttemptNumber}) => {
  const attempt = _.get(currentLifter, ['lifts', liftName, attemptNumber]);
  const weight = _.get(attempt, 'weight', '');
  const result = _.get(attempt, 'result', '');
  return (
    <div className={classNames('weight-cell', result, {'current-attempt': currentAttemptNumber === attemptNumber})} >{weight}</div>
  );
};


class Platform extends Component {

  render() {
    const { meet, currentAttempt, platform, currentLifter } = this.props;
    if(!platform || !meet) {
      return null;
    }

    const lifterName = _.get(currentLifter, 'name', '-------- ------------');
    const teamName = currentLifter ? _.get(currentLifter, 'team', '') : '-----------';
    const liftName =  _.get(currentAttempt, 'liftName', 'Lift');
    let liftDisplayName =  _.capitalize(liftName);
    if(liftName === 'bench' && meet.federation === 'USSF') {
      liftDisplayName = 'Press';
    }
    const currentAttemptNumber = _.get(currentAttempt, 'attemptNumber', '0');


    let divisionName = '---------------';
    let weightClassName = '---';

    if(currentLifter) {
      const firstLifterDivision = _.get(currentLifter, 'divisions.0', {});
      const divisionDoc = getDivisionDoc(firstLifterDivision.divisionId, meet);
      if(firstLifterDivision.divisionId && divisionDoc) {
        divisionName = _.get(divisionDoc, 'name');
        // don't display weightclass name if there is only one for this division
        const weightClassDoc = getLifterAwardsWeightClassDoc(meet, currentLifter, firstLifterDivision);
        weightClassName = _.size(divisionDoc.weightClasses) > 1 ? _.get(weightClassDoc, 'name') : '';
      }
    }

    return (
      <div className="platform2">
        <div className="platform-name">{platform.name}</div>
        <div className="platform-table">
          <div className="platform-table-row">
            <div>{lifterName}</div>
            { teamName && <div>{teamName}</div> }
            <div>{divisionName} - {weightClassName}</div>
          </div>
          <div className="platform-table-row">
            <div>{liftDisplayName}</div>
            <AttemptCell currentLifter={currentLifter} liftName={liftName} attemptNumber={'1'} currentAttemptNumber={currentAttemptNumber} />
            <AttemptCell currentLifter={currentLifter} liftName={liftName} attemptNumber={'2'} currentAttemptNumber={currentAttemptNumber} />
            <AttemptCell currentLifter={currentLifter} liftName={liftName} attemptNumber={'3'} currentAttemptNumber={currentAttemptNumber} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    platform: getCurrentPlatform(state, props),
    currentAttempt: getCurrentAttempt(state, props),
    currentLifter: getCurrentLifter(state, props)
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(Platform));
